// Bilingual UI strings (English + Miami-friendly Spanish).
// Missing keys fall back to English automatically (see i18n/index.js).
export const translations = {
  en: {
    // Nav labels
    "nav.home": "Home",
    "nav.business": "Business Waste",
    "nav.dumpsters": "Dumpster Rentals",
    "nav.recycling": "Recycling",
    "nav.calculator": "WiseWaste Calculator",
    "nav.about": "Who We Are",
    "nav.contact": "Contact",
    // Utility strip
    "util.hours": "Mon – Sat · 7am – 6pm",
    "util.serving": "Serving Miami-Dade County",
    "brand.tagline": "Zero Waste Committed",
    "home.seoTitle": "Miami Waste Management & Dumpster Rental | EWS",
    "home.seoDesc": "EWS provides commercial waste management and roll-off dumpster rentals across Miami-Dade. 2–8 yard business service and 10–40 yard dumpsters. Call (305) 691-1516.",
    "sc.seoTitle": "WiseWaste™ Waste Savings Calculator | EWS Miami",
    "sc.seoDesc": "Calculate commercial waste savings or scan your current waste bill for a fast EWS price review. Free WiseWaste tool for Miami-Dade businesses.",
    "common.heroMetaBrand": "EWS / Miami-Dade County",
    "common.heroMetaServices": "Front-load · Roll-off · Recycling",
    "common.heroMetaHours": "Mon–Sat · 7 AM–6 PM",
    "cta.localEyebrow": "Local Miami-Dade Service",
    "cta.localBody": "Talk directly with a local account manager about commercial waste pickup, roll-off dumpsters, or recycling service.",
    // CTAs / buttons
    "cta.quickQuote": "Quick Quote",
    "cta.getQuickQuote": "Get My Quick Quote",
    "cta.requestQuote": "Request A Free Quote",
    "cta.contact": "Contact Us",
    "dock.home": "Home",
    "dock.scan": "Scan",
    "dock.call": "Call",
    "dock.text": "Text",
    "dock.quote": "Quote",
    "cta.freeQuote": "Free Quote",
    "lang.switch": "Español",
    "lang.label": "ES",
    // Hero
    "hero.badge": "Miami's Affordable Waste Management Company",
    "hero.subtitle_a": "Commercial garbage service and roll-off dumpster rentals engineered for Miami's businesses, contractors, and industrial operations. Save up to",
    "hero.subtitle_b": "30% off",
    "hero.subtitle_c": "with us.",
    "hero.dumpsterChip": "1 – 8 Yard Dumpsters",
    "hero.saveChip": "Save Up To 30% Off",
    "hero.ratedGoogle": "· Rated on Google",
    "hero.bbb": "A+ BBB Rating",
    "hero.yearsExp": "Years of Experience",
    "hero.lines": ["Affordable, Simple", "Waste Management &", "Dumpster Rental", "Solutions."],
    "stat.0": "Years Experience",
    "stat.1": "Average Savings Per Customer",
    "stat.2": "Miami-Dade Areas Served",
    "stat.3": "Compliant Recycling & Disposal",
    // Home savings section
    "home.savings.eyebrow": "Instant AI Estimate",
    "home.savings.title": "Paying too much for waste pickup?",
    "home.savings.body": "Snap a photo of your current invoice and our AI gives you an instant savings estimate — then an EWS specialist reviews your bill personally to find even bigger savings.",
    "home.savings.patent": "Patent-Pending AI",
    "home.savings.learn": "· Learn more",
    // Testimonials
    "testi.eyebrow": "What Miami-Dade Says",
    "testi.title": "Trusted by businesses across the county",
    "testi.rated": "5.0 · Rated on Google",
    // Footer
    "footer.requestQuote": "Request A Free Quote",
    "footer.explore": "Explore",
    "footer.serviceAreas": "Service Areas",
    "footer.blog": "Blog",
    "footer.talk": "Let's Talk Trash Solutions",
    "footer.tagline": "Miami's affordable waste management & dumpster rental company. Over 30 years of reliable, sustainable service across Miami-Dade — zero waste committed.",
    "footer.services": "Waste Management · Dumpster Rental · Recycling",
    // Services section
    "services.eyebrow": "/ 01 — Waste Service",
    "services.title": "Our Waste Services",
    "services.blurb": "At EWS, we are dedicated to providing our clients with the best waste management solutions that are both effective and affordable — with over 25 years of experience.",
    "services.exploreBusiness": "Explore Business Waste Service",
    "services.exploreRolloff": "Explore Dumpster Rentals",
    // Why EWS
    "why.eyebrow": "/ 03 — The Manifesto",
    "why.title": "Why EWS Waste Services?",
    // Recycling (home)
    "rec.eyebrow": "/ 02 — Dumpster Rentals & Recycling",
    "rec.title1": "We Are Waste &",
    "rec.title2": "Recycling Pros",
    "rec.blurb": "No matter what's in your bin, we know what to do with it. We offer the most cost-effective disposal solutions in Miami, FL; transport waste safely; and find new uses for materials, including recycling and converting waste into energy.",
    "rec.badge": "Recycling · Waste-to-Energy",
    "rec.handle": "The waste & recycling we handle:",
    // Business Waste page
    "bw.seoTitle": "Commercial Waste Pickup in Miami-Dade | EWS",
    "bw.seoDesc": "Commercial front-load waste collection for Miami businesses from $55/mo. 2–8 yard dumpsters, 1–7x weekly pickup, and a written service guarantee.",
    "bw.crumb": "Business Waste Service",
    "bw.h1a": "Affordable & Simple Business Waste Management",
    "bw.h1b": "Solutions.",
    "bw.save": "Save Up To 30% Off With Us.",
    "bw.rolloffBtn": "Roll-Off Dumpsters",
    "bw.switchBanner": "Save Up To 30% By Switching To Our Company",
    "bw.introEyebrow": "Miami Commercial Waste",
    "bw.introTitle": "Miami Commercial Waste Services",
    "bw.affordable": "Affordable",
    "bw.dumpsterEyebrow": "1 – 8 Yard Dumpsters",
    "bw.dumpsterTitle": "Commercial Waste Service Dumpsters For All Type Of Businesses",
    "bw.frontloadCaption": "Front-load · 4′ H × 4′6″ D × 6′ W",
    "bw.guaranteeTitle": "Service Guarantee",
    "bw.sizesEyebrow": "Front-Load Sizes",
    "bw.sizesTitle": "Find The Right Dumpster",
    "bw.sizesHighlight": "Size",
    "bw.notSureTitle": "Not sure what you need?",
    "bw.notSureDesc": "Our specialists will help you find the perfect size for your business in one quick call.",
    "bw.viewDetails": "View Details",
    "bw.processEyebrow": "How It Works",
    "bw.processTitle": "Getting Started Is",
    "bw.processHighlight": "Simple",
    "bw.weeklyEyebrow": "Commercial Weekly Service",
    "bw.weeklyTitle": "Scheduled Weekly Waste Pickup For",
    "bw.weeklyHighlight": "Miami Businesses",
    "bw.weeklyCta": "Build my weekly schedule —",
    "bw.anyBusiness": "Waste Service For Any Business",
    "bw.faqEyebrow": "Commercial Waste FAQ",
    "bw.faqTitle": "Business Waste",
    "bw.faqHighlight": "Questions",
    "cta.ready": "Ready to lower your waste bill?",
    // Dumpster Rentals page
    "dr.seoTitle": "Dumpster Rental Miami | Roll-Off Dumpsters from $289 | EWS",
    "dr.seoDesc": "Roll-off dumpster rental in Miami and Miami-Dade from $289 for 14 days. 10–40 yard containers for construction, remodels, roofing, and cleanouts.",
    "dr.crumb": "Dumpster Rentals",
    "dr.eyebrow": "10 – 40 Yard Containers",
    "dr.title": "Roll-Off Dumpster",
    "dr.highlight": "Rentals.",
    "dr.subtitle": "Heavy-duty open-top containers delivered on your schedule — perfect for construction debris, cleanouts, roofing and major renovations across Miami & Miami-Dade County.",
    "dr.startingAt": "Starting at",
    "dr.priceFootnote": "* Flat-rate 14-day rental with reliable delivery & pickup. Final price varies by size, debris type and rental length.",
    "dr.introEyebrow": "Simple & Affordable",
    "dr.introTitle": "Efficient Roll-Off Dumpsters For",
    "dr.introHighlight": "Any Project",
    "dr.introBody": "EWS is your go-to for all your dumpster rental needs. Whether you are a business or a residence, we have the resources and the expertise to provide efficient and affordable roll-off dumpsters that range from 10 to 40 yards.",
    "dr.sizesEyebrow": "Container Sizes",
    "dr.sizesTitle": "Pick The Right",
    "dr.sizesHighlight": "Roll-Off",
    "dr.viewDetails": "View Details",
    "dr.anyTitleA": "We Rent Roll-Off Dumpsters For",
    "dr.anyTitleB": "Any Project",
    "dr.anyBody": "Our dumpster rental service offers a wide variety of dumpster sizes, ranging from 10-40 cubic yards, to suit any project. Whether you're cleaning out your garage, remodeling your home, or hauling away debris from a construction site, we have the right dumpster size to help you get the job done. With our convenient delivery and pickup options, you'll have your project completed in no time.",
    "dr.catWord": "Dumpsters",
    "dr.cat0.eyebrow": "Residential",
    "dr.cat0.body": "Our residential roll-off dumpster services make it easy to manage all the waste generated from your home renovation projects. We offer convenient delivery, flexible rental periods, and affordable rates so you can get the dumpster you need to keep your renovation project on track.",
    "dr.cat1.eyebrow": "Commercial",
    "dr.cat1.body": "We provide an easy and convenient solution for managing your commercial waste. Our range of commercial dumpsters ensures that you have the perfect size to keep your business site clean and organized — without a hassle.",
    "dr.cat2.eyebrow": "Construction",
    "dr.cat2.body": "We offer reliable and efficient waste management solutions for construction sites. We offer roll-off dumpsters to fit your needs, ensuring that your construction site remains clean and organized.",
    "dr.costEyebrow": "Transparent Pricing",
    "dr.costTitle": "How Much Does a Dumpster Rental",
    "dr.costHighlight": "Cost in Miami?",
    "dr.costIntro": "EWS keeps dumpster rental pricing simple and honest. Roll-off rentals start at $289 for a full 14-day rental period, with reliable delivery and pickup and a generous weight allowance built in — no hidden fuel charges or surprise fees. You pay one flat rate based on the container size and how long you keep it.",
    "dr.faqEyebrow": "Dumpster Rental FAQ",
    "dr.faqTitle": "Dumpster Rental",
    "dr.faqHighlight": "Questions",
    "dr.uses.0": "Construction & Demolition Debris",
    "dr.uses.1": "Home & Estate Cleanouts",
    "dr.uses.2": "Roofing Tear-Offs",
    "dr.uses.3": "Remodeling & Renovations",
    "dr.uses.4": "Landscaping & Yard Waste",
    "dr.uses.5": "Industrial Cleanups",
    "common.from": "from",
    // Dumpster Detail (per-size)
    "dd.eyebrowFront": "Front-Load Commercial Dumpster",
    "dd.eyebrowRoll": "Open-Top Roll-Off Dumpster",
    "dd.rentalsWord": "Rentals.",
    "dd.rentalsWord2": "Rentals",
    "dd.startingAt": "Starting at",
    "dd.priceFootnotePre": "* Pricing varies by location, pickup frequency and service level. Call",
    "dd.priceFootnotePost": "for an exact quote.",
    "dd.overview": "Overview",
    "dd.holds": "Holds:",
    "dd.dimensions": "Dimensions:",
    "dd.startingAtLabel": "Starting at:",
    "dd.perMonth": "per month",
    "dd.includes": "Includes:",
    "dd.idealFor": "Ideal For:",
    "dd.whatsIncluded": "What's Included:",
    "dd.howEyebrow": "How It Works",
    "dd.howTitle": "Getting Started Is",
    "dd.howHighlight": "Simple",
    "dd.faqEyebrow": "FAQ",
    "dd.faqTitle": "Common",
    "dd.faqHighlight": "Questions",
    "dd.compareEyebrow": "Compare Sizes",
    "dd.compareTitle": "Explore Other",
    "dd.compareHighlight": "Dumpster Sizes",
    "dd.perMo": "/mo",
    // City Landing pages
    "city.notFoundTitle": "Service Area Not Found",
    "city.notFoundPre": "We serve all of Miami-Dade County.",
    "city.notFoundLink": "View our dumpster rentals",
    "city.county": ", Miami-Dade County",
    "city.h1Pre": "Dumpster Rental & Waste Service in",
    "city.introFallback": "EWS is {city}'s trusted, affordable partner for commercial waste management and roll-off dumpster rentals. From front-load bins for local businesses to 40-yard containers for construction sites, we deliver across {city} with reliable delivery, flexible scheduling and up to 30% savings.",
    "city.quoteBtn": "Get A Free {city} Quote",
    "city.servicesEyebrowPre": "Serving",
    "city.servicesTitle": "Waste Services We Offer In",
    "city.localEyebrow": "Local Knowledge",
    "city.localTitlePre": "Serving Every Corner Of",
    "city.hoodsIntro": "Our trucks cover {city} neighborhood by neighborhood — including:",
    "city.permitTitlePre": "Dumpster Permits In",
    "city.projectsTitlePre": "Common Projects We Handle In",
    "city.sizesEyebrow": "Container Sizes",
    "city.sizesTitlePre": "Dumpster Sizes Available In",
    "city.viewDetails": "View Details",
    "city.frontloadLabel": "Front-Load {size} in {city}",
    "city.whyEyebrow": "Why EWS",
    "city.whyTitle": "{city}'s Reliable Waste",
    "city.whyHighlight": "Partner",
    "city.whyBody": "Businesses and residents in {city} choose EWS for transparent pricing, dependable pickups and friendly local service. With over 30 years serving Miami-Dade, we know {city} routes, permitting and scheduling — so your waste is handled without the headaches.",
    "city.whyFeatures": ["Reliable container delivery in {city}", "Save up to 30% vs. your current hauler", "Flexible weekly or on-call schedules", "Locally owned & 5-star rated"],
    "city.formHeading": "Request A Free Quote In {city}",
    "city.faqTitle": "Dumpster Rental In {city}",
    "city.faqHighlight": "Questions",
    "city.nearby": "Nearby Service Areas",
    "city.nearbyLinkPre": "Dumpster Rental in",
    "city.seoTitle": "Dumpster Rental & Waste Service in {city}, FL | EWS",
    "city.seoDesc": "Dumpster rental and commercial waste service in {city}, FL. Front-load 2–8 yard and roll-off 10–40 yard dumpsters with transparent pricing. Call {phone}.",
    "city.baseFaq0q": "How much does a dumpster rental cost in {city}?",
    "city.baseFaq0a": "Dumpster rental in {city} depends on size and how long you keep the container. Roll-off dumpsters start at $289 for a 14-day rental and front-load commercial service starts near $55/month. Call {phone} for an exact {city} quote — we'll beat or match competitor pricing.",
    "city.baseFaq1q": "Do you offer same-week dumpster delivery in {city}?",
    "city.baseFaq1a": "Yes. EWS delivers roll-off and front-load dumpsters throughout {city} and neighboring Miami-Dade communities, usually within the same week and often next day.",
    "city.baseFaq2q": "What size dumpster do I need for a project in {city}?",
    "city.baseFaq2a": "For most {city} home cleanouts and remodels a 10–20 yard roll-off works well; larger construction jobs use 30–40 yard. Businesses typically use 2–8 yard front-load bins. Our team will help you pick the right size in one call.",
    // Who We Are
    "wwa.seoTitle": "About EWS | 30+ Years of Miami-Dade Waste Management",
    "wwa.seoDesc": "EWS is a locally owned Miami-Dade waste management company with 30+ years of experience in commercial waste, roll-off dumpsters, and recycling.",
    "wwa.crumb": "Who We Are",
    "wwa.eyebrow": "Zero Waste Committed",
    "wwa.title": "Miami's Trusted Waste",
    "wwa.highlight": "Partner.",
    "wwa.subtitle": "Over 30 years of affordable, reliable and sustainable waste management across Miami-Dade County.",
    "wwa.storyEyebrow": "Our Story",
    "wwa.storyTitle": "Local, Reliable &",
    "wwa.storyHighlight": "Sustainable",
    "wwa.whyEyebrow": "Why EWS",
    "wwa.whyTitle": "Why Businesses",
    "wwa.whyHighlight": "Choose Us",
    // Recycling page
    "rp.seoTitle": "Commercial Recycling Services in Miami-Dade | EWS",
    "rp.seoDesc": "Commercial recycling for Miami businesses, including cardboard, paper, plastics, metal, pallets, and diversion programs that help reduce landfill costs.",
    "rp.crumb": "Recycling",
    "rp.eyebrow": "Waste & Recycling Pros",
    "rp.title": "Recycling &",
    "rp.highlight": "Disposal Solutions.",
    "rp.subtitle": "No matter what's in your bin, we know what to do with it. We offer the most cost-effective disposal solutions in Miami — transporting waste safely and finding new uses for materials.",
    "rp.commitEyebrow": "Committed To Sustainability",
    "rp.commitTitle": "We Are Waste &",
    "rp.commitHighlight": "Recycling Pros",
    "rp.p0t": "We Sort & Recycle",
    "rp.p0d": "We divert as much material as possible from landfill through responsible sorting and recycling.",
    "rp.p1t": "Waste-to-Energy",
    "rp.p1d": "Materials that can't be recycled are converted into energy wherever possible.",
    "rp.p2t": "A Sustainable Future",
    "rp.p2d": "We help businesses reduce, reuse and recycle to hit their environmental goals.",
    "rp.handleEyebrow": "What We Handle",
    "rp.handleTitle": "The Waste & Recycling",
    "rp.handleHighlight": "We Handle",
    "rp.seoEyebrow": "Recycling In Miami",
    "rp.seoTitle2": "Commercial Recycling That",
    "rp.seoHighlight": "Saves You Money",
    "rp.copy1": "Recycling isn't just good for the environment — for most Miami businesses it's a smart way to cut disposal costs. By diverting cardboard (OCC), paper, plastics, metal and glass out of your trash and into a dedicated recycling stream, you reduce the volume headed to the landfill and often lower your overall monthly bill.",
    "rp.copy2": "EWS sets up right-sized recycling alongside your regular waste pickup — from single-stream commercial recycling for offices and retail, to cardboard-heavy programs for warehouses and shopping centers, to construction & demolition (C&D) debris recycling on job sites across Miami-Dade County.",
    // Contact
    "ct.seoTitle": "Contact EWS | Miami Waste Management & Dumpster Rental",
    "ct.seoDesc": "Contact EWS for dumpster rental and commercial waste service in Miami-Dade. Call (305) 691-1516 or request a free quote — our account managers respond fast.",
    "ct.crumb": "Contact",
    "ct.eyebrow": "Let's Talk Trash Solutions",
    "ct.title": "Get In",
    "ct.highlight": "Touch.",
    "ct.subtitle": "Need help? Talk to one of our account managers today. We'll help you find the perfect waste and recycling plan for your business.",
    "ct.callUs": "Call Us",
    "ct.emailUs": "Email Us",
    "ct.visit": "Visit / Mail",
    "ct.serviceArea": "Service Area",
    "ct.hours": "Hours",
    "ct.hoursValue": "Mon – Sat · 7am – 6pm",
    "lead.heading": "Send us a message",
    "lead.defaultHeading": "Request A Free Quote",
    "lead.name": "Full Name *",
    "lead.business": "Business Name",
    "lead.email": "Email Address *",
    "lead.phone": "Phone Number *",
    "lead.serviceNeeded": "Service Needed *",
    "lead.frequency": "Frequency",
    "lead.quantity": "Quantity",
    "lead.containerWord": "container",
    "lead.containersWord": "containers",
    "lead.message": "Message / Job Details",
    "lead.submit": "Submit Request",
    "lead.submitting": "Submitting…",
    "lead.priceNote": "We'll beat or match our competition's pricing",
    "lead.validation": "Please fill in your name, email, phone and service needed.",
    "lead.successToast": "Thanks for submitting! Our account managers will be in touch shortly.",
    "lead.errorToast": "Something went wrong. Please call us at ",
    "lead.doneTitle": "Thanks for submitting!",
    "lead.doneBody": "One of our account managers will reach out shortly. Need immediate help? Call ",
    "lead.another": "Submit Another Request",
    "lead.svc.business": "Business Waste Service",
    "lead.svc.rolloff": "Roll-Off Dumpster Service",
    "lead.svc.recycling": "Recycling",
    "lead.svc.other": "Other / Not Sure",
    "lead.sizeLabel.business": "Container Size",
    "lead.sizeLabel.rolloff": "Dumpster Size",
    // Floating CTAs
    "scan.bubbleBold": "Curious what you'd save?",
    "scan.bubble": " Snap your current waste bill — get an instant quote in seconds.",
    "scan.title": "Scan Your Invoice",
    "scan.sub": "Instant quote & savings",
    "scan.patent": "Patent-Pending AI",
    "scan.learn": "· Learn more",
    "text.bubbleBold": "No time to fill a form?",
    "text.bubble": " Just text us for a faster reply.",
    "text.us": "Text Us",
    "text.fast": "Fast reply",
    "text.call": "Call Now",
    // Quick Quote
    "qq.seoTitle": "Request a Free Dumpster Rental & Waste Quote | Miami | EWS",
    "qq.seoDesc": "Request a free quote for commercial waste service or roll-off dumpster rental in Miami-Dade. Transparent pricing, fast response, and local EWS support.",
    "qq.crumb": "Quick Quote",
    "qq.eyebrow": "Free · No Obligation",
    "qq.title": "Request A",
    "qq.highlight": "Free Quote.",
    "qq.subtitle": "Get the best prices for waste management services in Miami. Tell us about your needs and our account managers will be in touch — or call for an instant quote over the phone.",
    "qq.callToday": "Call Us Today",
    "qq.whatsNext": "What happens next",
    "qq.formHeading": "Tell us about your waste needs",
    // Blog
    "blog.seoTitle": "Waste & Dumpster Rental Blog | EWS Miami-Dade",
    "blog.seoDesc": "Expert tips on dumpster rental, commercial garbage service and recycling across Miami-Dade — from Miami and Hialeah to Doral, Aventura and beyond.",
    "blog.crumb": "Blog",
    "blog.eyebrow": "Insights & Guides",
    "blog.title": "The EWS",
    "blog.highlight": "Waste Journal.",
    "blog.subtitle": "Dumpster rental, commercial garbage service and recycling tips for businesses and homeowners across Miami-Dade County.",
    "blog.featured": "Featured",
    "blog.readArticle": "Read Article",
    "blog.readMore": "Read More",
    "cat.All": "All",
    "cat.Dumpster Rental": "Dumpster Rental",
    "cat.Commercial Garbage": "Commercial Garbage",
    "cat.Construction": "Construction",
    "cat.Recycling": "Recycling",
    // Blog Post
    "bp.allArticles": "All Articles",
    "bp.readyTitle": "Ready for reliable service in",
    "bp.readyBody": "EWS delivers affordable dumpster rental & commercial garbage service across Miami-Dade.",
    "bp.getQuote": "Get a Free Quote",
    "bp.keepReading": "Keep Reading",
    "bp.read": "Read",
    // Service Areas
    "sa.seoTitle": "Dumpster Rental & Waste Service Areas in Miami-Dade County | EWS",
    "sa.seoDesc": "EWS provides dumpster rental and commercial waste service across all of Miami-Dade County — Hialeah, Doral, Kendall, Homestead, Coral Gables, Miami Beach, Aventura, Miami Lakes and 30+ more. Reliable delivery, flat-rate pricing.",
    "sa.crumb": "Service Areas",
    "sa.communities": "Miami-Dade Communities",
    "sa.title": "Our Service",
    "sa.highlight": "Coverage Map.",
    "sa.subtitle": "We provide an affordable, more reliable waste service solution across Miami, FL and the surrounding Miami-Dade communities. Explore the interactive map or search for your city.",
    "sa.interactive": "Interactive coverage · click a city to zoom in",
    "sa.searchPlaceholder": "Search your city…",
    "sa.areasWord": "areas",
    "sa.noMatch": "No match — call us to confirm coverage.",
    "sa.featuredEyebrow": "Featured Cities",
    "sa.featuredTitle": "Local Dumpster Rental",
    "sa.featuredHighlight": "Guides",
    "sa.featuredIntro": "Detailed local guides for the Miami-Dade communities we serve most — with neighborhood coverage, permit notes and the projects we handle in each city.",
    "sa.viewGuidePre": "View",
    "sa.viewGuidePost": "Guide",
    "sa.allEyebrow": "All Communities",
    "sa.allTitleA": "We Serve Every City & Neighborhood In",
    "sa.allTitleB": "Miami-Dade",
    "sa.allBody": "Don't see your area below? We still cover it. Call us and we'll confirm delivery to your address the same day.",
    "sa.plate": "City Coverage Map",
    "sa.countyLine": "Miami-Dade County, FL",
    "sa.coords": "LAT 25.87°N · LON 80.20°W",
    "sa.street": "Streets",
    "sa.aerial": "Aerial",
    "sa.mapFoot": "Basemap: OpenStreetMap / Esri",
    "sa.coverageFoot": "Miami-Dade coverage · Mon–Sat 7 AM–6 PM",
    "sa.glance": "Coverage at a glance",
    "sa.citiesServed": "Communities served",
    "sa.countyServed": "County covered",
    "sa.glanceBody": "We serve businesses across Miami-Dade County. Search or choose a city to locate it on the map.",
    "sa.legendService": "Service area",
    "sa.legendSelected": "Selected city",
    "sa.legendRadius": "Coverage radius",
    "sa.cityIndex": "City Index",
    "sa.cityIndexSub": "City · County",
    "sa.cityCounty": "Miami-Dade",
    // Savings Calculator
    "calc.title": "Snap your invoice, see your savings",
    "calc.sub": "Upload a photo of your current waste bill. Our AI reads it instantly and shows how much you'd save with EWS.",
    "calc.upload": "Take a photo or upload your invoice",
    "calc.reading": "Reading your invoice with AI…",
    "calc.currentLabel": "Your current monthly cost",
    "calc.ewsPrice": "EWS price",
    "calc.less": "less",
    "calc.detected": "Detected hauler:",
    "calc.svcDetails": "Your service details",
    "calc.svcDetailsAi": "— AI-detected, edit if needed",
    "calc.svcDetailsAdd": "— add if known",
    "calc.phSize": "Container size (e.g. 4 yard)",
    "calc.phFreq": "Frequency (e.g. 2x/week)",
    "calc.phQty": "Quantity",
    "calc.saveMonth": "You save / month",
    "calc.saveYear": "You save / year",
    "calc.aiNote": "This is what our EWS AI estimates from your invoice — a fast, conservative first look. Share it with us and one of our representatives will personally study your bill to see if we can save you even more. We'll be in touch shortly.",
    "calc.reachYou": "Send your invoice to a specialist — where should we reach you?",
    "calc.phName": "Full name *",
    "calc.phBusiness": "Business name",
    "calc.phEmail": "Email *",
    "calc.phPhone": "Phone *",
    "calc.phAddress": "Service address",
    "calc.sending": "Sending…",
    "calc.sendBtn": "Send My Invoice To A Specialist",
    "calc.startOver": "Start over",
    "calc.doneTitle": "Our AI estimates ~{amt}/year in savings",
    "calc.doneBody": "Thanks! We've received your invoice. One of our EWS representatives will personally review it to see if we can save you even more, and reach out shortly. Prefer to talk now? Call ",
    "calc.again": "Calculate another invoice",
    "calc.errImg": "Please upload an image of your invoice.",
    "calc.errRead": "Could not read the invoice. Try a clearer photo or enter the amount manually.",
    "calc.infoAmount": "We couldn't read the amount clearly — please type your monthly cost below.",
    "calc.errContact": "Please add your name, email and phone.",
    "calc.errAmount": "Please enter your current monthly cost.",
    "calc.errGeneric": "Something went wrong. Please call ",
    // Service Area Check (home)
    "sac.title": "Waste Management In Miami",
    "sac.body": "EWS is a reputable and trusted provider of Miami waste management services, catering to the needs of commercial businesses of all sizes. We understand the importance of proper waste management in Miami, FL, in maintaining clean and sustainable communities. We offer a comprehensive range of services designed to meet the unique needs of businesses in Miami.",
    "sac.check": "Check if we service your area!",
    "sac.selectCity": "Select your city…",
    "sac.checkBtn": "Check Availability",
    "sac.cutting1": "Businesses in",
    "sac.cutting2": "are cutting costs by up to 30%!",
    "sac.ensures1": "EWS ensures",
    "sac.ensures2": "businesses pay only what they should. Get your free quote and switch at no cost, without any hassle.",
    "sac.available1": "Commercial waste service available in",
    "sac.name": "Your name or business *",
    "sac.namePh": "e.g. John Doe",
    "sac.phone": "Phone number *",
    "sac.email": "Email *",
    "sac.emailPh": "e.g. quick@saving.com",
    "sac.consent1": "By clicking below",
    "sac.consent2": ", you agree to receive messages from EWS. This agreement isn't a condition of any purchase. Message and data rates may apply. Reply STOP to opt out.",
    "sac.sending": "Sending…",
    "sac.getQuote": "Get my Free Quote!",
    "sac.getQuoteShort": "Get my Free Quote",
    "sac.allSet": "You're all set!",
    "sac.thanks1": "Thanks",
    "sac.thanks2": "— one of our EWS experts will call you shortly with your free quote for",
    // Language switch aria
    "lang.toEnglish": "English",
    "lang.toSpanish": "Español",
  },
  es: {
    // Nav labels
    "nav.home": "Inicio",
    "nav.business": "Basura Comercial",
    "nav.dumpsters": "Renta de Dumpsters",
    "nav.recycling": "Reciclaje",
    "nav.calculator": "Calculadora WiseWaste",
    "nav.about": "Quiénes Somos",
    "nav.contact": "Contacto",
    // Utility strip
    "util.hours": "Lun – Sáb · 7am – 6pm",
    "util.serving": "Servimos el Condado de Miami-Dade",
    "brand.tagline": "Comprometidos con Cero Residuos",
    "home.seoTitle": "Manejo de Residuos y Renta de Dumpsters en Miami | EWS",
    "home.seoDesc": "EWS ofrece manejo de residuos comerciales y renta de dumpsters roll-off en Miami-Dade. Servicio de 2–8 yardas y dumpsters de 10–40 yardas. Llama al (305) 691-1516.",
    "sc.seoTitle": "Calculadora WiseWaste™ de Ahorro en Residuos | EWS Miami",
    "sc.seoDesc": "Calcula ahorros en residuos comerciales o escanea tu factura actual para una revisión rápida de precio EWS. Herramienta gratis para negocios en Miami-Dade.",
    "common.heroMetaBrand": "EWS / Condado de Miami-Dade",
    "common.heroMetaServices": "Front-load · Roll-off · Reciclaje",
    "common.heroMetaHours": "Lun–Sáb · 7 AM–6 PM",
    "cta.localEyebrow": "Servicio Local en Miami-Dade",
    "cta.localBody": "Habla directamente con un asesor local sobre recolección comercial, dumpsters roll-off o reciclaje.",
    // CTAs / buttons
    "cta.quickQuote": "Cotización Rápida",
    "cta.getQuickQuote": "Obtener Mi Cotización",
    "cta.requestQuote": "Solicita una Cotización Gratis",
    "cta.contact": "Contáctanos",
    "dock.home": "Inicio",
    "dock.scan": "Escanear",
    "dock.call": "Llamar",
    "dock.text": "Texto",
    "dock.quote": "Cotizar",
    "cta.freeQuote": "Cotización Gratis",
    "lang.switch": "English",
    "lang.label": "EN",
    // Hero
    "hero.badge": "La Compañía de Manejo de Residuos Más Económica de Miami",
    "hero.subtitle_a": "Servicio de basura comercial y renta de dumpsters roll-off diseñados para los negocios, contratistas y operaciones industriales de Miami. Ahorra hasta un",
    "hero.subtitle_b": "30%",
    "hero.subtitle_c": "con nosotros.",
    "hero.dumpsterChip": "Dumpsters de 1 a 8 Yardas",
    "hero.saveChip": "Ahorra Hasta un 30%",
    "hero.ratedGoogle": "· Calificados en Google",
    "hero.bbb": "Calificación A+ del BBB",
    "hero.yearsExp": "Años de Experiencia",
    "hero.lines": ["Soluciones de Manejo", "de Residuos y Renta", "de Dumpsters —", "Simples y Económicas."],
    "stat.0": "Años de Experiencia",
    "stat.1": "Ahorro Promedio por Cliente",
    "stat.2": "Áreas Servidas en Miami-Dade",
    "stat.3": "Reciclaje y Disposición 100% Conforme",
    // Home savings section
    "home.savings.eyebrow": "Estimado Instantáneo con IA",
    "home.savings.title": "¿Pagas de más por la recolección de basura?",
    "home.savings.body": "Toma una foto de tu factura actual y nuestra IA te da un estimado de ahorro al instante — luego un especialista de EWS revisa tu factura personalmente para encontrar ahorros aún mayores.",
    "home.savings.patent": "IA con Patente en Trámite",
    "home.savings.learn": "· Más información",
    // Testimonials
    "testi.eyebrow": "Lo Que Dice Miami-Dade",
    "testi.title": "La confianza de negocios en todo el condado",
    "testi.rated": "5.0 · Calificados en Google",
    // Footer
    "footer.requestQuote": "Solicita una Cotización Gratis",
    "footer.explore": "Explorar",
    "footer.serviceAreas": "Áreas de Servicio",
    "footer.blog": "Blog",
    "footer.talk": "Hablemos de Soluciones de Basura",
    "footer.tagline": "La compañía de manejo de residuos y renta de dumpsters más económica de Miami. Más de 30 años de servicio confiable y sostenible en todo Miami-Dade — comprometidos con cero residuos.",
    "footer.services": "Manejo de Residuos · Renta de Dumpsters · Reciclaje",
    // Services section
    "services.eyebrow": "/ 01 — Servicio de Residuos",
    "services.title": "Nuestros Servicios de Residuos",
    "services.blurb": "En EWS nos dedicamos a brindar a nuestros clientes las mejores soluciones de manejo de residuos, efectivas y económicas — con más de 25 años de experiencia.",
    "services.exploreBusiness": "Ver Servicio de Basura Comercial",
    "services.exploreRolloff": "Ver Renta de Dumpsters",
    // Why EWS
    "why.eyebrow": "/ 03 — El Manifiesto",
    "why.title": "¿Por Qué Elegir EWS?",
    // Recycling (home)
    "rec.eyebrow": "/ 02 — Renta de Dumpsters y Reciclaje",
    "rec.title1": "Somos Expertos en",
    "rec.title2": "Residuos y Reciclaje",
    "rec.blurb": "No importa qué haya en tu contenedor, sabemos qué hacer con ello. Ofrecemos las soluciones de disposición más económicas de Miami, FL; transportamos los residuos de forma segura; y encontramos nuevos usos para los materiales, incluyendo el reciclaje y la conversión de residuos en energía.",
    "rec.badge": "Reciclaje · Residuos a Energía",
    "rec.handle": "Los residuos y el reciclaje que manejamos:",
    // Business Waste page
    "bw.seoTitle": "Recolección de Basura Comercial en Miami-Dade | EWS",
    "bw.seoDesc": "Recolección comercial front-load para negocios en Miami desde $55/mes. Dumpsters de 2–8 yardas, recolección de 1–7 veces por semana y garantía escrita.",
    "bw.crumb": "Servicio de Basura Comercial",
    "bw.h1a": "Soluciones Simples y Económicas de Manejo de Basura Comercial",
    "bw.h1b": "para tu Negocio.",
    "bw.save": "Ahorra Hasta un 30% con Nosotros.",
    "bw.rolloffBtn": "Dumpsters Roll-Off",
    "bw.switchBanner": "Ahorra Hasta un 30% Cambiándote a Nuestra Compañía",
    "bw.introEyebrow": "Basura Comercial en Miami",
    "bw.introTitle": "Servicios de Basura Comercial en Miami",
    "bw.affordable": "Económico",
    "bw.dumpsterEyebrow": "Dumpsters de 1 a 8 Yardas",
    "bw.dumpsterTitle": "Dumpsters de Basura Comercial Para Todo Tipo de Negocio",
    "bw.frontloadCaption": "Front-load · 4′ Alto × 4′6″ Prof × 6′ Ancho",
    "bw.guaranteeTitle": "Garantía de Servicio",
    "bw.sizesEyebrow": "Tamaños Front-Load",
    "bw.sizesTitle": "Encuentra el Tamaño de",
    "bw.sizesHighlight": "Dumpster Ideal",
    "bw.notSureTitle": "¿No sabes qué necesitas?",
    "bw.notSureDesc": "Nuestros especialistas te ayudarán a encontrar el tamaño perfecto para tu negocio en una llamada rápida.",
    "bw.viewDetails": "Ver Detalles",
    "bw.processEyebrow": "Cómo Funciona",
    "bw.processTitle": "Empezar Es Muy",
    "bw.processHighlight": "Sencillo",
    "bw.weeklyEyebrow": "Servicio Semanal Comercial",
    "bw.weeklyTitle": "Recolección Semanal Programada Para",
    "bw.weeklyHighlight": "Negocios en Miami",
    "bw.weeklyCta": "Arma mi horario semanal —",
    "bw.anyBusiness": "Servicio de Basura Para Cualquier Negocio",
    "bw.faqEyebrow": "Preguntas de Basura Comercial",
    "bw.faqTitle": "Preguntas Sobre",
    "bw.faqHighlight": "Basura Comercial",
    "cta.ready": "¿Listo para bajar tu factura de basura?",
    // Dumpster Rentals page
    "dr.seoTitle": "Renta de Dumpsters en Miami | Roll-Off desde $289 | EWS",
    "dr.seoDesc": "Renta de dumpsters roll-off en Miami y Miami-Dade desde $289 por 14 días. Contenedores de 10–40 yardas para construcción, remodelación, techos y limpiezas.",
    "dr.crumb": "Renta de Dumpsters",
    "dr.eyebrow": "Contenedores de 10 a 40 Yardas",
    "dr.title": "Renta de Dumpsters",
    "dr.highlight": "Roll-Off.",
    "dr.subtitle": "Contenedores abiertos de uso rudo entregados según tu horario — perfectos para escombro de construcción, limpiezas, techos y renovaciones mayores en Miami y el Condado de Miami-Dade.",
    "dr.startingAt": "Desde",
    "dr.priceFootnote": "* Renta de 14 días a tarifa plana con entrega y recolección confiables. El precio final varía según el tamaño, el tipo de escombro y la duración de la renta.",
    "dr.introEyebrow": "Simple y Económico",
    "dr.introTitle": "Dumpsters Roll-Off Eficientes Para",
    "dr.introHighlight": "Cualquier Proyecto",
    "dr.introBody": "EWS es tu opción para todas tus necesidades de renta de dumpsters. Ya seas un negocio o una residencia, tenemos los recursos y la experiencia para ofrecerte dumpsters roll-off eficientes y económicos que van desde las 10 hasta las 40 yardas.",
    "dr.sizesEyebrow": "Tamaños de Contenedor",
    "dr.sizesTitle": "Elige el",
    "dr.sizesHighlight": "Roll-Off Correcto",
    "dr.viewDetails": "Ver Detalles",
    "dr.anyTitleA": "Rentamos Dumpsters Roll-Off Para",
    "dr.anyTitleB": "Cualquier Proyecto",
    "dr.anyBody": "Nuestro servicio de renta de dumpsters ofrece una amplia variedad de tamaños, desde 10 hasta 40 yardas cúbicas, para adaptarse a cualquier proyecto. Ya sea que estés limpiando tu garaje, remodelando tu hogar o retirando escombro de un sitio de construcción, tenemos el tamaño correcto para ayudarte a terminar el trabajo. Con nuestras cómodas opciones de entrega y recolección, completarás tu proyecto en poco tiempo.",
    "dr.catWord": "Dumpsters",
    "dr.cat0.eyebrow": "Residencial",
    "dr.cat0.body": "Nuestro servicio de dumpsters roll-off residenciales facilita el manejo de todos los residuos generados por tus proyectos de renovación del hogar. Ofrecemos entrega cómoda, periodos de renta flexibles y tarifas económicas para mantener tu proyecto en marcha.",
    "dr.cat1.eyebrow": "Comercial",
    "dr.cat1.body": "Brindamos una solución fácil y cómoda para manejar tus residuos comerciales. Nuestra gama de dumpsters comerciales garantiza que tengas el tamaño perfecto para mantener tu sitio de negocio limpio y organizado — sin complicaciones.",
    "dr.cat2.eyebrow": "Construcción",
    "dr.cat2.body": "Ofrecemos soluciones de manejo de residuos confiables y eficientes para sitios de construcción. Contamos con dumpsters roll-off que se adaptan a tus necesidades, asegurando que tu sitio se mantenga limpio y organizado.",
    "dr.costEyebrow": "Precios Transparentes",
    "dr.costTitle": "¿Cuánto Cuesta la Renta de un Dumpster",
    "dr.costHighlight": "en Miami?",
    "dr.costIntro": "EWS mantiene los precios de renta simples y honestos. Las rentas roll-off comienzan en $289 por un periodo completo de 14 días, con entrega y recolección confiables y un generoso peso incluido — sin cargos ocultos de combustible ni sorpresas. Pagas una sola tarifa plana según el tamaño del contenedor y el tiempo que lo conserves.",
    "dr.faqEyebrow": "Preguntas de Renta de Dumpsters",
    "dr.faqTitle": "Preguntas Sobre",
    "dr.faqHighlight": "Renta de Dumpsters",
    "dr.uses.0": "Escombro de Construcción y Demolición",
    "dr.uses.1": "Limpiezas de Casas y Propiedades",
    "dr.uses.2": "Retiro de Techos",
    "dr.uses.3": "Remodelaciones y Renovaciones",
    "dr.uses.4": "Jardinería y Residuos de Patio",
    "dr.uses.5": "Limpiezas Industriales",
    "common.from": "desde",
    // Dumpster Detail (per-size)
    "dd.eyebrowFront": "Dumpster Comercial Front-Load",
    "dd.eyebrowRoll": "Dumpster Roll-Off Abierto",
    "dd.rentalsWord": "",
    "dd.rentalsWord2": "",
    "dd.startingAt": "Desde",
    "dd.priceFootnotePre": "* El precio varía según la ubicación, la frecuencia de recolección y el nivel de servicio. Llama al",
    "dd.priceFootnotePost": "para una cotización exacta.",
    "dd.overview": "Resumen",
    "dd.holds": "Capacidad:",
    "dd.dimensions": "Dimensiones:",
    "dd.startingAtLabel": "Desde:",
    "dd.perMonth": "al mes",
    "dd.includes": "Incluye:",
    "dd.idealFor": "Ideal Para:",
    "dd.whatsIncluded": "Lo Que Incluye:",
    "dd.howEyebrow": "Cómo Funciona",
    "dd.howTitle": "Empezar Es Muy",
    "dd.howHighlight": "Sencillo",
    "dd.faqEyebrow": "Preguntas",
    "dd.faqTitle": "Preguntas",
    "dd.faqHighlight": "Frecuentes",
    "dd.compareEyebrow": "Compara Tamaños",
    "dd.compareTitle": "Explora Otros",
    "dd.compareHighlight": "Tamaños de Dumpster",
    "dd.perMo": "/mes",
    // City Landing pages
    "city.notFoundTitle": "Área de Servicio No Encontrada",
    "city.notFoundPre": "Servimos todo el Condado de Miami-Dade.",
    "city.notFoundLink": "Ver nuestra renta de dumpsters",
    "city.county": ", Condado de Miami-Dade",
    "city.h1Pre": "Renta de Dumpsters y Servicio de Basura en",
    "city.introFallback": "EWS es el socio confiable y económico de {city} para el manejo de residuos comerciales y la renta de dumpsters roll-off. Desde contenedores front-load para negocios locales hasta contenedores de 40 yardas para sitios de construcción, entregamos en todo {city} con entrega confiable, horarios flexibles y hasta un 30% de ahorro.",
    "city.quoteBtn": "Obtén una Cotización Gratis en {city}",
    "city.servicesEyebrowPre": "Servimos",
    "city.servicesTitle": "Servicios de Residuos que Ofrecemos en",
    "city.localEyebrow": "Conocimiento Local",
    "city.localTitlePre": "Servimos Cada Rincón de",
    "city.hoodsIntro": "Nuestros camiones cubren {city} vecindario por vecindario — incluyendo:",
    "city.permitTitlePre": "Permisos de Dumpster en",
    "city.projectsTitlePre": "Proyectos Comunes que Manejamos en",
    "city.sizesEyebrow": "Tamaños de Contenedor",
    "city.sizesTitlePre": "Tamaños de Dumpster Disponibles en",
    "city.viewDetails": "Ver Detalles",
    "city.frontloadLabel": "Front-Load {size} en {city}",
    "city.whyEyebrow": "Por Qué EWS",
    "city.whyTitle": "El Socio Confiable de Residuos de {city}",
    "city.whyHighlight": "",
    "city.whyBody": "Los negocios y residentes de {city} eligen a EWS por sus precios transparentes, recolecciones confiables y un servicio local cercano. Con más de 30 años sirviendo a Miami-Dade, conocemos las rutas, permisos y horarios de {city} — para que tus residuos se manejen sin dolores de cabeza.",
    "city.whyFeatures": ["Entrega confiable de contenedores en {city}", "Ahorra hasta un 30% vs. tu proveedor actual", "Horarios flexibles semanales o a demanda", "De propiedad local y calificados 5 estrellas"],
    "city.formHeading": "Solicita una Cotización Gratis en {city}",
    "city.faqTitle": "Renta de Dumpsters en {city}",
    "city.faqHighlight": "Preguntas",
    "city.nearby": "Áreas de Servicio Cercanas",
    "city.nearbyLinkPre": "Renta de Dumpsters en",
    "city.seoTitle": "Renta de Dumpsters y Servicio de Basura en {city}, FL | EWS",
    "city.seoDesc": "Renta de dumpsters y servicio de basura comercial en {city}, FL. Dumpsters front-load de 2–8 yardas y roll-off de 10–40 yardas con precios transparentes. Llama al {phone}.",
    "city.baseFaq0q": "¿Cuánto cuesta la renta de un dumpster en {city}?",
    "city.baseFaq0a": "La renta de un dumpster en {city} depende del tamaño y del tiempo que conserves el contenedor. Los dumpsters roll-off comienzan en $289 por una renta de 14 días y el servicio comercial front-load comienza cerca de $55/mes. Llama al {phone} para una cotización exacta en {city} — igualamos o mejoramos el precio de la competencia.",
    "city.baseFaq1q": "¿Ofrecen entrega de dumpster la misma semana en {city}?",
    "city.baseFaq1a": "Sí. EWS entrega dumpsters roll-off y front-load en todo {city} y las comunidades cercanas de Miami-Dade, normalmente la misma semana y a menudo al día siguiente.",
    "city.baseFaq2q": "¿Qué tamaño de dumpster necesito para un proyecto en {city}?",
    "city.baseFaq2a": "Para la mayoría de las limpiezas y remodelaciones del hogar en {city} funciona bien un roll-off de 10 a 20 yardas; los trabajos de construcción más grandes usan de 30 a 40 yardas. Los negocios suelen usar contenedores front-load de 2 a 8 yardas. Nuestro equipo te ayudará a elegir el tamaño correcto en una llamada.",
    // Who We Are
    "wwa.seoTitle": "Acerca de EWS | 30+ Años de Manejo de Residuos en Miami-Dade",
    "wwa.seoDesc": "EWS es una compañía local de manejo de residuos en Miami-Dade con más de 30 años de experiencia en basura comercial, dumpsters roll-off y reciclaje.",
    "wwa.crumb": "Quiénes Somos",
    "wwa.eyebrow": "Comprometidos con Cero Residuos",
    "wwa.title": "El Socio de Residuos de Confianza",
    "wwa.highlight": "de Miami.",
    "wwa.subtitle": "Más de 30 años de manejo de residuos económico, confiable y sostenible en todo el Condado de Miami-Dade.",
    "wwa.storyEyebrow": "Nuestra Historia",
    "wwa.storyTitle": "Local, Confiable y",
    "wwa.storyHighlight": "Sostenible",
    "wwa.whyEyebrow": "Por Qué EWS",
    "wwa.whyTitle": "Por Qué los Negocios",
    "wwa.whyHighlight": "Nos Eligen",
    // Recycling page
    "rp.seoTitle": "Servicios de Reciclaje Comercial en Miami-Dade | EWS",
    "rp.seoDesc": "Reciclaje comercial para negocios en Miami, incluyendo cartón, papel, plásticos, metal, pallets y programas de desvío que ayudan a reducir costos de relleno sanitario.",
    "rp.crumb": "Reciclaje",
    "rp.eyebrow": "Expertos en Residuos y Reciclaje",
    "rp.title": "Soluciones de Reciclaje",
    "rp.highlight": "y Disposición.",
    "rp.subtitle": "No importa qué haya en tu contenedor, sabemos qué hacer con ello. Ofrecemos las soluciones de disposición más económicas de Miami — transportando los residuos de forma segura y dando nuevos usos a los materiales.",
    "rp.commitEyebrow": "Comprometidos con la Sostenibilidad",
    "rp.commitTitle": "Somos Expertos en",
    "rp.commitHighlight": "Residuos y Reciclaje",
    "rp.p0t": "Clasificamos y Reciclamos",
    "rp.p0d": "Desviamos del vertedero la mayor cantidad posible de material mediante una clasificación y reciclaje responsables.",
    "rp.p1t": "Residuos a Energía",
    "rp.p1d": "Los materiales que no se pueden reciclar se convierten en energía siempre que es posible.",
    "rp.p2t": "Un Futuro Sostenible",
    "rp.p2d": "Ayudamos a los negocios a reducir, reutilizar y reciclar para alcanzar sus metas ambientales.",
    "rp.handleEyebrow": "Lo Que Manejamos",
    "rp.handleTitle": "Los Residuos y el Reciclaje",
    "rp.handleHighlight": "Que Manejamos",
    "rp.seoEyebrow": "Reciclaje en Miami",
    "rp.seoTitle2": "Reciclaje Comercial Que",
    "rp.seoHighlight": "Te Ahorra Dinero",
    "rp.copy1": "El reciclaje no solo es bueno para el medio ambiente — para la mayoría de los negocios en Miami es una forma inteligente de reducir costos de disposición. Al desviar cartón (OCC), papel, plásticos, metal y vidrio de tu basura hacia un flujo de reciclaje dedicado, reduces el volumen que va al vertedero y a menudo bajas tu factura mensual total.",
    "rp.copy2": "EWS configura un reciclaje del tamaño adecuado junto con tu recolección de basura habitual — desde reciclaje comercial de flujo único para oficinas y comercios, hasta programas con mucho cartón para almacenes y centros comerciales, y reciclaje de escombro de construcción y demolición (C&D) en obras de todo el Condado de Miami-Dade.",
    // Contact
    "ct.seoTitle": "Contacta a EWS | Manejo de Residuos y Renta de Dumpsters en Miami",
    "ct.seoDesc": "Contacta a EWS para renta de dumpsters y servicio de basura comercial en Miami-Dade. Llama al (305) 691-1516 o solicita una cotización gratis — nuestros asesores responden rápido.",
    "ct.crumb": "Contacto",
    "ct.eyebrow": "Hablemos de Soluciones de Basura",
    "ct.title": "Ponte en",
    "ct.highlight": "Contacto.",
    "ct.subtitle": "¿Necesitas ayuda? Habla hoy con uno de nuestros asesores. Te ayudaremos a encontrar el plan de residuos y reciclaje perfecto para tu negocio.",
    "ct.callUs": "Llámanos",
    "ct.emailUs": "Escríbenos",
    "ct.visit": "Visítanos / Correo",
    "ct.serviceArea": "Área de Servicio",
    "ct.hours": "Horario",
    "ct.hoursValue": "Lun – Sáb · 7am – 6pm",
    "lead.heading": "Envíanos un mensaje",
    "lead.defaultHeading": "Solicita una Cotización Gratis",
    "lead.name": "Nombre Completo *",
    "lead.business": "Nombre del Negocio",
    "lead.email": "Correo Electrónico *",
    "lead.phone": "Número de Teléfono *",
    "lead.serviceNeeded": "Servicio que Necesitas *",
    "lead.frequency": "Frecuencia",
    "lead.quantity": "Cantidad",
    "lead.containerWord": "contenedor",
    "lead.containersWord": "contenedores",
    "lead.message": "Mensaje / Detalles del Trabajo",
    "lead.submit": "Enviar Solicitud",
    "lead.submitting": "Enviando…",
    "lead.priceNote": "Igualamos o mejoramos el precio de la competencia",
    "lead.validation": "Por favor completa tu nombre, correo, teléfono y el servicio que necesitas.",
    "lead.successToast": "¡Gracias por tu solicitud! Nuestros asesores se comunicarán contigo pronto.",
    "lead.errorToast": "Algo salió mal. Por favor llámanos al ",
    "lead.doneTitle": "¡Gracias por tu solicitud!",
    "lead.doneBody": "Uno de nuestros asesores se comunicará contigo pronto. ¿Necesitas ayuda inmediata? Llama al ",
    "lead.another": "Enviar Otra Solicitud",
    "lead.svc.business": "Servicio de Basura Comercial",
    "lead.svc.rolloff": "Servicio de Dumpster Roll-Off",
    "lead.svc.recycling": "Reciclaje",
    "lead.svc.other": "Otro / No Estoy Seguro",
    "lead.sizeLabel.business": "Tamaño del Contenedor",
    "lead.sizeLabel.rolloff": "Tamaño del Dumpster",
    // Floating CTAs
    "scan.bubbleBold": "¿Curioso por cuánto ahorrarías?",
    "scan.bubble": " Toma una foto de tu factura actual — recibe una cotización al instante.",
    "scan.title": "Escanea tu Factura",
    "scan.sub": "Cotización y ahorro al instante",
    "scan.patent": "IA con Patente en Trámite",
    "scan.learn": "· Más información",
    "text.bubbleBold": "¿Sin tiempo para llenar un formulario?",
    "text.bubble": " Escríbenos por mensaje para una respuesta más rápida.",
    "text.us": "Escríbenos",
    "text.fast": "Respuesta rápida",
    "text.call": "Llámanos",
    // Quick Quote
    "qq.seoTitle": "Solicita una Cotización Gratis de Renta de Dumpsters y Basura | Miami | EWS",
    "qq.seoDesc": "Solicita una cotización gratis para basura comercial o renta de dumpsters roll-off en Miami-Dade. Precios transparentes, respuesta rápida y apoyo local de EWS.",
    "qq.crumb": "Cotización Rápida",
    "qq.eyebrow": "Gratis · Sin Compromiso",
    "qq.title": "Solicita una",
    "qq.highlight": "Cotización Gratis.",
    "qq.subtitle": "Obtén los mejores precios en servicios de manejo de residuos en Miami. Cuéntanos qué necesitas y nuestros asesores se comunicarán contigo — o llama para una cotización al instante por teléfono.",
    "qq.callToday": "Llámanos Hoy",
    "qq.whatsNext": "Qué sigue",
    "qq.formHeading": "Cuéntanos sobre tus necesidades de residuos",
    // Blog
    "blog.seoTitle": "Blog de Residuos y Renta de Dumpsters | EWS Miami-Dade",
    "blog.seoDesc": "Consejos expertos sobre renta de dumpsters, servicio de basura comercial y reciclaje en todo Miami-Dade — desde Miami e Hialeah hasta Doral, Aventura y más.",
    "blog.crumb": "Blog",
    "blog.eyebrow": "Ideas y Guías",
    "blog.title": "El Diario de",
    "blog.highlight": "Residuos de EWS.",
    "blog.subtitle": "Consejos sobre renta de dumpsters, servicio de basura comercial y reciclaje para negocios y residentes de todo el Condado de Miami-Dade.",
    "blog.featured": "Destacado",
    "blog.readArticle": "Leer Artículo",
    "blog.readMore": "Leer Más",
    "cat.All": "Todos",
    "cat.Dumpster Rental": "Renta de Dumpsters",
    "cat.Commercial Garbage": "Basura Comercial",
    "cat.Construction": "Construcción",
    "cat.Recycling": "Reciclaje",
    // Blog Post
    "bp.allArticles": "Todos los Artículos",
    "bp.readyTitle": "¿Listo para un servicio confiable en",
    "bp.readyBody": "EWS ofrece renta de dumpsters y servicio de basura comercial económicos en todo Miami-Dade.",
    "bp.getQuote": "Obtén una Cotización Gratis",
    "bp.keepReading": "Sigue Leyendo",
    "bp.read": "Leer",
    // Service Areas
    "sa.seoTitle": "Áreas de Servicio de Renta de Dumpsters y Basura en Miami-Dade | EWS",
    "sa.seoDesc": "EWS ofrece renta de dumpsters y servicio de basura comercial en todo el Condado de Miami-Dade — Hialeah, Doral, Kendall, Homestead, Coral Gables, Miami Beach, Aventura, Miami Lakes y más de 30 comunidades. Entrega confiable, tarifa plana.",
    "sa.crumb": "Áreas de Servicio",
    "sa.communities": "Comunidades de Miami-Dade",
    "sa.title": "Nuestro Mapa de",
    "sa.highlight": "Cobertura.",
    "sa.subtitle": "Ofrecemos una solución de servicio de residuos económica y más confiable en Miami, FL y las comunidades cercanas de Miami-Dade. Explora el mapa interactivo o busca tu ciudad.",
    "sa.interactive": "Cobertura interactiva · haz clic en una ciudad para acercar",
    "sa.searchPlaceholder": "Busca tu ciudad…",
    "sa.areasWord": "áreas",
    "sa.noMatch": "Sin coincidencias — llámanos para confirmar la cobertura.",
    "sa.featuredEyebrow": "Ciudades Destacadas",
    "sa.featuredTitle": "Guías Locales de",
    "sa.featuredHighlight": "Renta de Dumpsters",
    "sa.featuredIntro": "Guías locales detalladas para las comunidades de Miami-Dade que más servimos — con cobertura por vecindario, notas sobre permisos y los proyectos que manejamos en cada ciudad.",
    "sa.viewGuidePre": "Ver Guía de",
    "sa.viewGuidePost": "",
    "sa.allEyebrow": "Todas las Comunidades",
    "sa.allTitleA": "Servimos Cada Ciudad y Vecindario de",
    "sa.allTitleB": "Miami-Dade",
    "sa.allBody": "¿No ves tu área abajo? Igual la cubrimos. Llámanos y confirmaremos la entrega a tu dirección el mismo día.",
    "sa.plate": "Mapa de Cobertura por Ciudad",
    "sa.countyLine": "Condado de Miami-Dade, FL",
    "sa.coords": "LAT 25.87°N · LON 80.20°O",
    "sa.street": "Calles",
    "sa.aerial": "Aérea",
    "sa.mapFoot": "Mapa base: OpenStreetMap / Esri",
    "sa.coverageFoot": "Cobertura en Miami-Dade · Lun–Sáb 7 AM–6 PM",
    "sa.glance": "Cobertura de un vistazo",
    "sa.citiesServed": "Comunidades atendidas",
    "sa.countyServed": "Condado cubierto",
    "sa.glanceBody": "Servimos negocios en todo el Condado de Miami-Dade. Busca o elige una ciudad para ubicarla en el mapa.",
    "sa.legendService": "Área de servicio",
    "sa.legendSelected": "Ciudad seleccionada",
    "sa.legendRadius": "Radio de cobertura",
    "sa.cityIndex": "Índice de Ciudades",
    "sa.cityIndexSub": "Ciudad · Condado",
    "sa.cityCounty": "Miami-Dade",
    // Savings Calculator
    "calc.title": "Toma una foto de tu factura, ve tu ahorro",
    "calc.sub": "Sube una foto de tu factura de basura actual. Nuestra IA la lee al instante y te muestra cuánto ahorrarías con EWS.",
    "calc.upload": "Toma una foto o sube tu factura",
    "calc.reading": "Leyendo tu factura con IA…",
    "calc.currentLabel": "Tu costo mensual actual",
    "calc.ewsPrice": "Precio EWS",
    "calc.less": "menos",
    "calc.detected": "Proveedor detectado:",
    "calc.svcDetails": "Detalles de tu servicio",
    "calc.svcDetailsAi": "— detectado por IA, edita si es necesario",
    "calc.svcDetailsAdd": "— agrégalos si los conoces",
    "calc.phSize": "Tamaño del contenedor (ej. 4 yardas)",
    "calc.phFreq": "Frecuencia (ej. 2x/semana)",
    "calc.phQty": "Cantidad",
    "calc.saveMonth": "Ahorras / mes",
    "calc.saveYear": "Ahorras / año",
    "calc.aiNote": "Esto es lo que nuestra IA de EWS estima a partir de tu factura — un primer vistazo rápido y conservador. Compártelo con nosotros y uno de nuestros representantes estudiará tu factura personalmente para ver si podemos ahorrarte aún más. Nos comunicaremos contigo pronto.",
    "calc.reachYou": "Envía tu factura a un especialista — ¿dónde te contactamos?",
    "calc.phName": "Nombre completo *",
    "calc.phBusiness": "Nombre del negocio",
    "calc.phEmail": "Correo *",
    "calc.phPhone": "Teléfono *",
    "calc.phAddress": "Dirección de servicio",
    "calc.sending": "Enviando…",
    "calc.sendBtn": "Enviar Mi Factura a un Especialista",
    "calc.startOver": "Empezar de nuevo",
    "calc.doneTitle": "Nuestra IA estima ~{amt}/año en ahorros",
    "calc.doneBody": "¡Gracias! Recibimos tu factura. Uno de nuestros representantes de EWS la revisará personalmente para ver si podemos ahorrarte aún más, y se comunicará pronto. ¿Prefieres hablar ahora? Llama al ",
    "calc.again": "Calcular otra factura",
    "calc.errImg": "Por favor sube una imagen de tu factura.",
    "calc.errRead": "No pudimos leer la factura. Prueba con una foto más clara o ingresa el monto manualmente.",
    "calc.infoAmount": "No pudimos leer el monto con claridad — por favor escribe tu costo mensual abajo.",
    "calc.errContact": "Por favor agrega tu nombre, correo y teléfono.",
    "calc.errAmount": "Por favor ingresa tu costo mensual actual.",
    "calc.errGeneric": "Algo salió mal. Por favor llama al ",
    // Service Area Check (home)
    "sac.title": "Manejo de Residuos en Miami",
    "sac.body": "EWS es un proveedor confiable y de buena reputación de servicios de manejo de residuos en Miami, atendiendo las necesidades de negocios comerciales de todos los tamaños. Entendemos la importancia del manejo adecuado de residuos en Miami, FL, para mantener comunidades limpias y sostenibles. Ofrecemos una amplia gama de servicios diseñados para las necesidades únicas de los negocios en Miami.",
    "sac.check": "¡Verifica si servimos tu área!",
    "sac.selectCity": "Selecciona tu ciudad…",
    "sac.checkBtn": "Verificar Disponibilidad",
    "sac.cutting1": "Los negocios en",
    "sac.cutting2": "están reduciendo costos hasta un 30%!",
    "sac.ensures1": "EWS asegura que los negocios en",
    "sac.ensures2": "paguen solo lo justo. Obtén tu cotización gratis y cámbiate sin costo, sin complicaciones.",
    "sac.available1": "Servicio de basura comercial disponible en",
    "sac.name": "Tu nombre o negocio *",
    "sac.namePh": "ej. Juan Pérez",
    "sac.phone": "Número de teléfono *",
    "sac.email": "Correo *",
    "sac.emailPh": "ej. rapido@ahorro.com",
    "sac.consent1": "Al hacer clic abajo",
    "sac.consent2": ", aceptas recibir mensajes de EWS. Este acuerdo no es condición de ninguna compra. Pueden aplicar tarifas de mensajes y datos. Responde STOP para cancelar.",
    "sac.sending": "Enviando…",
    "sac.getQuote": "¡Obtén mi Cotización Gratis!",
    "sac.getQuoteShort": "Obtén mi Cotización Gratis",
    "sac.allSet": "¡Todo listo!",
    "sac.thanks1": "Gracias",
    "sac.thanks2": "— uno de nuestros expertos de EWS te llamará pronto con tu cotización gratis para",
    // Language switch aria
    "lang.toEnglish": "English",
    "lang.toSpanish": "Español",
  },
};
